<template>
  <footer class="ftr">
    <div class="ftr__inner">
      <div class="ftr__brand-row">
        <img class="ftr__logo" :src="logoUrl" alt="Idoing" width="24" height="24" />
        <strong class="ftr__brand">Idoing</strong>
        <!-- <p class="ftr__copy">面向开发者的 API 开放平台 · Vue 2</p> -->
      </div>
      <div class="ftr__links">
        <router-link to="/type/all">所有产品</router-link>
        <router-link to="/docs">文档</router-link>
        <!-- <router-link to="/console">控制台</router-link> -->
      </div>
    </div>
  </footer>
</template>

<script>
import { BRAND_LOGO_URL } from '../utils/brand'

export default {
  name: 'AppFooter',
  data() {
    return { logoUrl: BRAND_LOGO_URL }
  }
}
</script>

<style scoped>
.ftr {
  border-top: 1px solid var(--line);
  background: rgba(0, 0, 0, 0.25);
}
.ftr__inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 28px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-end;
}
.ftr__brand-row {
  display: grid;
  grid-template-columns: 24px 1fr;
  column-gap: 10px;
  align-items: center;
}
.ftr__logo {
  grid-row: 1 / span 2;
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 5px;
  background: #0a0a0a;
}
.ftr__brand {
  font-family: var(--font-display);
  font-size: 16px;
}
.ftr__copy {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--muted);
  grid-column: 2;
}
.ftr__links {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: var(--muted);
}
.ftr__links a:hover {
  color: var(--accent);
}
</style>
